export const subscribeToNewsletter = async (params: { email: string; firstName?: string; lastName?: string }) => {
    const res = await fetch("/api/newsletter", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(params),
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok) {
        throw new Error(json?.message || "Subscription failed");
    }
    return json as { message: string };
};


